import React, { useEffect, useState } from 'react';
import { Button, Typography } from '@mui/material';
import questions from '../data/questions';
import Question from '../types/question';
import Flashcard from '../components/Flashcard';

const Play: React.FC = () => {
  const [listQuestions, setListQuestions] = useState<Question[]>(questions);
  const [currentQuestion, setCurrentQuestion] = useState<Question | null>(null);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const excludeOpened = localStorage.getItem('excludeOpened') === 'true';

  useEffect(() => {
    if (isButtonDisabled) {
      let timer: NodeJS.Timeout;
      timer = setTimeout(() => {
        setIsButtonDisabled(false);
      }, 300); // 300ms delay
      return () => clearTimeout(timer);
    }
  }, [isButtonDisabled]);

  const removeOpenedQuestions = (randomIndex: number) => {
    // Remove the question from the list
    if (listQuestions.length === 1) {
      setListQuestions(questions);
    } else {
      setListQuestions(
        listQuestions.filter((_, index) => index !== randomIndex)
      );
    }
  }

  const getRandomQuestion = () => {
    if (isButtonDisabled) return;

    setIsButtonDisabled(true);
    const randomIndex = Math.floor(Math.random() * listQuestions.length);
    setCurrentQuestion(listQuestions[randomIndex]);
    if (excludeOpened) {
      removeOpenedQuestions(randomIndex);
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: '50px',
      }}
    >
      {/* remain questions */}
      {excludeOpened && (
        <Typography variant="h6" gutterBottom>
          {listQuestions.length} questions remaining
        </Typography>
      )}
      <Flashcard question={currentQuestion} />
      <Button
        variant="contained"
        color="primary"
        onClick={getRandomQuestion}
        loading={isButtonDisabled}
      >
        Get Random Question
      </Button>
      <Button
        variant="contained"
        color="secondary"
        href="/"
        style={{ marginTop: '20px' }}
      >
        Back to Home
      </Button>
    </div>
  );
};

export default Play;
